import AddPromotion from './Add.jsx';
import EditPromotion from './Edit.jsx';
import ListPromotions from './List.jsx';

export {AddPromotion, EditPromotion, ListPromotions};



// WEBPACK FOOTER //
// ./pages/promotions/index.js